module.exports = __webpack_public_path__ + "static/media/House1.471e1cf8.svg";